import { type FileError } from "react-dropzone";
import { BACKEND_UPLOAD_FACTOR, FRONTEND_UPLOAD_FACTOR, MAX_UPLOAD_SIZE } from "./consts";
import { FileWithProgress } from "./types";

export const isValidFileType = (file: File): boolean => {
  const validTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/rtf",
    "text/plain",
  ];
  const fileExtension = file.name.split(".").pop()?.toLowerCase();
  return (
    validTypes.includes(file.type) ||
    ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "odt", "odp", "ods", "rtf", "txt"].includes(
      fileExtension || "",
    )
  );
};

export const formatFileErrors = (errors: readonly FileError[]): string =>
  errors
    .map(error => error.message)
    .join(", ")
    .replace(`than ${MAX_UPLOAD_SIZE} bytes`, `than ${MAX_UPLOAD_SIZE / 1024 / 1024} MB`);

export const processNewFiles = (files: File[]): FileWithProgress[] =>
  files.map(file => ({
    file,
    progress: 0,
    status: "pending" as const,
    error: isValidFileType(file) ? undefined : "Invalid file type",
    tx_id: "",
  }));

export const calculateUploadProgress = (progress: number) =>
  (progress * BACKEND_UPLOAD_FACTOR + FRONTEND_UPLOAD_FACTOR) * 100;
